import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import organization_profile_setup_address_methods from "./organization_profile_setup_address_methods";
import organization_profile_setup_branding_methods from "./organization_profile_setup_branding_methods";
import organization_profile_setup_core_methods from "./organization_profile_setup_core_methods";

export default {
  components: {
    HomeNavBar,
  },

  data: () => ({
    user_details: {},
    token_exists: false,
    company: {},
    logo_file: null,
    cover_file: null,
    isDraggingLogo: false,
    saving_profile: false,
    address_list: {
      street_address: "",
      suburb: "",
      town: "",
      province: "",
      postal_code: "",
      country: "",
    },
    latitude: null,
    longitude: null,
    form: {
      organization_name: "",
      type_of_organization: "",
      description: "",
      email: "",
      tell_number: "",
      location: "",
      logo_preview: "",
      cover_preview: "",
      primary_color: "",
      secondary_color: "",
      tertiary_color: "",
    },
    saved_branding: null,
    organization_address_autocomplete: null,
    organization_address_input: null,
  }),

  computed: {
    branding_style() {
      const style = {};

      if (this.form.primary_color) {
        style["--primary-color"] = this.form.primary_color;
        style["--accent-color"] = this.form.primary_color;
      }

      if (this.form.secondary_color) {
        style["--secondary-color"] = this.form.secondary_color;
      }

      if (this.form.tertiary_color) {
        style["--tertiary-color"] = this.form.tertiary_color;
      }

      return style;
    },
  },

  mounted() {
    this.token_exists = !!get_token();
    this.user_details = get_user_details() || {};
    this.saved_branding = this.get_saved_branding();

    this.prefill_form();
    this.fetch_company_profile();
    this.apply_branding_to_platform(this.get_branding_payload());
    this.load_google_places();
  },

  methods: {
    ...organization_profile_setup_core_methods,
    ...organization_profile_setup_address_methods,
    ...organization_profile_setup_branding_methods,
  },
};
